<template>
  <layout
    :titlePage="'Cadastro de Chave PIX'"
    :route="{ name: 'carteira-saque' }"
  >
    <submenuBack v-if="hasToShowNewMenu" />
    <section class="pix-register-validation">
      <div class="columns columns--full pix-register-account--margin-top-0">
        <div
          class="column is-two-fifths pix-register-account--header-custom pix-register-account--header pix-register-validation__header-page"
        >
          <base-header-page class="pix-register-account__header-page">
            <base-icon name="pix" width="160px" height="40px" />
          </base-header-page>
        </div>
        <div class="column pix-register-validation__content">
          <div class="pix-register-account__steps-pix" style="min-width: 70%">
            <BaseSteps :steps="steps" content="pix" />
          </div>
          <div
            class="pix-register-validation__content--full-height"
            :class="{ 'margin-top-10': verified }"
          >
            <h2>
              {{ title }}
            </h2>
            <div
              v-if="!enabledToUse"
              class="pix-register-validation__content--msg"
              :class="{ 'margin-top-24': !enabledToUse }"
            >
              <p>
                Sua chave será validada até às<br />
                <span>
                  <span>23h59 de </span>
                  {{ this.$route.params.enabled_to_use_at | dateWithoutHours }}
                </span>
              </p>
            </div>
            <div
              class="pix-register-validation__validation-email"
              v-if="!verified"
            >
              <p v-if="!enabledToUse">
                Para prosseguirmos com este processo, por favor, confirme a
                solicitação de cadastro da chave PIX no e-mail enviado para<br />
                <span>{{ this.$route.params.email }}</span>
              </p>
              <p v-else>
                Para que você possa iniciar as suas transferências,
                <span>é necessário que você confirme</span> esta solicitação de
                cadastro de chave PIX no e-mail que enviamos para
                <span>{{ this.$route.params.email }}</span>
              </p>
            </div>

            <a
              href="https://ajuda.casar.com/support/solutions/articles/73000559538-por-que-minha-chave-pix-passa-por-um-processo-de-validac%C3%A3o-"
              target="_blank"
              class="pix-register-validation__faq-validation"
              :class="{ 'margin-top-40': verified }"
              >Quer entender melhor o motivo dessas validações? Clique aqui e
              saiba mais ;)</a
            >

            <hr v-if="!verified" />

            <div class="pix-register-validation__resend-email" v-if="!verified">
              <p class="pix-register-validation__resend-email--title">
                Não recebeu o nosso e-mail?
              </p>
              <p class="pix-register-validation__resend-email--subtitle">
                Pode acontecer do e-mail demorar um pouquinho para chegar até
                você. Lembre-se de verificar também em sua caixa de SPAM. Se
                ainda assim não receber o e-mail, clique no botão abaixo para
                que possamos reenviá-lo ;)
              </p>

              <div class="pix-register-validation__btn-footer">
                <base-button-bottom
                  :disabled="btnIsNotAvailable"
                  @click.native="resendCode()"
                  :class="{ 'is-disabled': btnIsNotAvailable }"
                  class="button is-support is-big pix-register-validation__btn-footer--send-cod"
                  type="button"
                >
                  {{ sendCodeAgain }}
                </base-button-bottom>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import submenuBack from '@/layouts/parts/SubmenuBack.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'
import BaseHeaderPage from '@/components/BaseHeaderPage.vue'

import imgSuccessfull from '@/assets/img/icon-check-pix.png'
import imgClock from '@/assets/img/clock.png'

import BaseSteps from '@/components/Wallet/BaseSteps.vue'

import WalletApi from '@/lib/api/Wallet'

export default {
  data() {
    return {
      enabledToUse: '',
      btnIsNotAvailable: true,
      error: false,
      verified: '',
      title:
        'Recebemos o cadastro da sua chave PIX e agora ela está em processo de validação ;)',
      sendCodeAgain: 'Reenviar código',
      time: null,
      second: null,
      min: null,
      imgSuccessfull,
      imgClock,
      steps: [
        {
          step: 'Titular',
          active: true,
        },
        {
          step: 'Chave PIX',
          active: true,
        },
        {
          step: 'Validação',
          active: true,
        },
        {
          step: 'Conclusão',
        },
      ],
    }
  },

  computed: {
    userDataTransfer() {
      return this.$store.state.wallet.userDataTransfer
    },

    logonToken() {
      return this.$store.state.app.logonToken
    },

    hasToShowNewMenu() {
      return this.$store.state.app.wedSiteInfo.site_menu_versao ? true : false
    },
  },

  components: {
    layout,
    submenuBack,
    BaseHeaderPage,
    BaseSteps,
    BaseButtonBottom,
  },

  created() {
    const getTime = localStorage.getItem(`time${this.$route.params.id}`)

    this.$route.params.verified == 1
      ? (this.verified = true)
      : (this.verified = false)

    this.$route.params.enabled_to_use == 1
      ? (this.enabledToUse = true)
      : (this.enabledToUse = false)

    !this.$route.params.data || !this.$route.params.email
      ? this.$router.push({ name: 'carteira-saque' })
      : ''

    this.getTimeButton(getTime)
  },

  mounted() {
    if (this.verified && !this.enabledToUse) {
      //not verified
      this.title =
        'Sua solicitação de cadastro de chave PIX foi confirmada e está em processo de validação ;)'
    } else if (this.enabledToUse) {
      this.title =
        'Validamos a sua chave PIX! Agora só falta você confirmar o seu e-mail ;)'
    }
  },

  methods: {
    async getTimeButton(time) {
      var sec = 0
      var timeStorage = new Date(time)
      const milissegunds = Date.now() - timeStorage.getTime()

      // When time is less then 180 seconds
      if (milissegunds < 180000) {
        sec = 180000 - milissegunds

        const seconds = sec / 1000

        await this.countDownTimer(parseInt(seconds))
        this.btnIsNotAvailable = true
      } else {
        this.btnIsNotAvailable = false
      }
    },

    getSecond(second) {
      return 60 * parseInt(second)
    },

    // function to exact minutes. Ex: 240, 180, 120 etc
    countDownTimer(timeSecond) {
      if (timeSecond) {
        this.time = timeSecond
        this.min = timeSecond / 60
        this.second = timeSecond - this.getSecond(this.min)
      }

      this.sendCodeAgain =
        'Reenviar código em ' +
        parseInt(this.min) +
        ':' +
        this.formatSecund(this.second)

      if (this.time > 0) {
        this.countDown = setTimeout(() => {
          this.second == 0
            ? ((this.min = this.min - 1), (this.second = 60))
            : ''
          this.second -= 1
          this.time -= 1
          this.countDownTimer()
        }, 1000)
      } else {
        this.btnIsNotAvailable = false
        this.sendCodeAgain = 'Reenviar código'
      }
    },

    formatSecund(second) {
      if (second < 10) {
        return `0${second}`
      } else {
        return second
      }
    },

    resendCode() {
      const accountApi = new WalletApi(this.logonToken)
      accountApi
        .sendEmailValidationAccountPix(this.$route.params.id)
        .then((response) => {
          this.btnIsNotAvailable = true
          localStorage.setItem(
            `time${this.$route.params.id}`,
            response.data.meta.created_date
          )
          this.getTimeButton(response.data.meta.created_date)
        })
        .catch((error) => {
          console.error(error)
          this.error = error.data.message
        })
    },
  },
}
</script>

<style lang="scss">
.pix-register-account {
  &--margin-top-0 {
    margin-top: 0;
  }

  &__header-page {
    background-color: $support;
    @media (min-width: $tablet) {
      .svg-icon {
        width: 260px;
        height: 80px;
      }
    }
  }

  &--header-custom {
    padding: 0;
    max-width: 360px;
    margin: auto;

    @media (min-width: $desktop) {
      max-width: 582px;
    }
  }
}

.pix-register-validation {
  &__header-page {
    header {
      width: 100%;
    }

    @media (min-width: $tablet) {
      margin: 30px 0px;
      display: flex;
      align-items: center;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 0px 30px !important;
    margin: 30px 0px;

    &--full-height {
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }

    h2 {
      color: $neutraldarkest;
      font-family: Lato;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      max-width: 548px;
      margin-top: 57px;
    }

    &--msg {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      max-width: 548px;
      margin-top: 40px;
      margin-bottom: 16px;

      p {
        font-family: Lato;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: $neutral;
        span {
          color: $tertiary;
          font-weight: bold;
        }
      }
    }
  }

  &__validation-email {
    max-width: 548px;
    margin: 0 auto;
    padding: 20px 16px;
    border-radius: 8px;
    border: solid 1px $neutrallight;
    background-color: $neutrallightest;
    margin-top: 19px;
    margin-bottom: 27px;
    text-align: center;

    p {
      color: $neutraldarkest;

      span {
        font-weight: bold;
      }
    }
  }

  &__faq-validation {
    color: #3dafb0;
    font-size: 14px;
    font-weight: bold;
    margin-top: 8px;
  }

  hr {
    width: 100%;
    max-width: 548px;
    margin: 2.3rem 0;
    background-color: #dee7ea;
  }

  &__resend-email {
    max-width: 548px;
    margin: 0 auto;

    &--title {
      font-family: Lato;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: $neutral;
      margin-bottom: 10px;
    }

    &--subtitle {
      font-family: Lato;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.6;
      letter-spacing: normal;
      color: $neutral;
      margin-bottom: 32px;
    }
  }

  &__btn-footer {
    display: flex;
    justify-content: center;
    align-items: center;

    &--send-cod {
      width: 100% !important;
      max-width: 240px !important;
      border-radius: 24px;
      display: flex;
      justify-content: center;
      align-content: center;
      color: #fff;
      padding: 8px 0px;
      font-size: 16px;
      font-weight: bold;
    }

    .button.is-support[disabled],
    fieldset[disabled] .button.is-support {
      border-color: transparent !important;
      background-color: #b4c5d6cc !important;
    }
  }
}

.margin-top-40 {
  margin-top: 40px;
}

.margin-top-24 {
  margin-top: 24px;
}

.margin-top-10 {
  margin-top: -10%;
}
</style>
